// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container that holds both the player and the list */
.movies-container {
    display: flex;
    flex-direction: row;
    min-height: 100vh;
    font-family: Arial, sans-serif;
    background-color: #121827;
  }
  
  /* RESPONSIVE: For screens below 768px wide, switch to column layout */
  @media (max-width: 768px) {
    .movies-container {
      flex-direction: column;
    }
  }
  
  /* Left side: the video player area */
  .player-container {
    flex: 3 1;
    padding: 2rem;
    display: flex;
    flex-direction: column;
  }
  
  @media (max-width: 768px) {
    .player-container {
      flex: none;
      width: 100%; 
      padding: 1rem;
    }
  }
  
  /* Title at the top of the player */
  .page-title {
    font-size: 2.8rem;
    margin-bottom: 1rem;
    padding-top: 20px;
    text-align: center;
    color: #E4B300;
  }
  
  /* 16:9 Video Wrapper */
  .iframe-wrapper {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    margin-bottom: 1rem;
    background-color: #000;
    border-radius: 10px;
    border: 2px solid #c79c00;
  }
  
  .video-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    border: 2px solid #c79c00;
  }
  
  
  /* Make the video title smaller on small screens */
  @media (max-width: 768px) {
    .video-title {
      font-size: 2rem;
    }
  }
  
  /* INTRODUCTION CARD */
  .intro-card {
    background-color: #161d2f;
    border: 1px solid #121827;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 1rem 1.2rem;
    margin-bottom: 1rem;
  }
  
  .intro-title {
    margin-bottom: 0.5rem;
    font-size: 1.3rem;
    font-weight: bold;
    color: #E4B300;
  }
  
  .intro-text {
    font-size: 1rem;
    line-height: 1.5;
    color: #777;
  }
  
  /* SUMMARY BUTTON */
  .summary-btn {
    background-color: #E4B300;
    color: #121827;
    border: none;
    padding: 0.6rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 1rem;
    font-size: 1rem;
    transition: background 0.2s ease;
  }
  
  .summary-btn:hover {
    background-color: #F4CC00;
  }
  
  /* SUMMARY TEXT CONTAINER */
  .movie-summary {
    background-color: #161d2f;
    border-radius: 4px;
    padding: 1rem;
    margin-bottom: 1rem;
    font-size: 1rem;
    color: #777;
  }
  
  /* Right side: Video List Sidebar */
  .Vsidebar {
    flex: 1 1;
    background-color: #161d2f;
    border-left: 1px solid #121827;
    padding: 2rem;
    display: flex;
    flex-direction: column;
  }
  
  .Vsidebar-title {
    font-size: 1.6rem;
    margin-bottom: 1rem;
    color: #E4B300;
  }
  
  /* Video List */
  .video-list {
    list-style-type: none;
  }
  
  .video-list-item {
    cursor: pointer;
    padding: 0.6rem 1rem;
    margin-bottom: 0.5rem;
    border-radius: 4px;
    color: #999;
    transition: background 0.2s ease;
  }
  
  .video-list-item:hover {
    background-color: #F4CC00;
    color: #121827;
  }
  
  .active {
    background-color: #E4B300;
    font-weight: bold;
    color: #121827;
  }
  
  /* RESPONSIVE: For screens below 768px wide, place the sidebar under the player */
  @media (max-width: 768px) {
    .Vsidebar {
      flex: none; 
      width: 100%;
      border-left: none;
      border-top: 1px solid #161d2f;
      padding: 1rem;
      order: 2;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/User/Movies.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA,sEAAsE;EACtE;IACE;MACE,sBAAsB;IACxB;EACF;;EAEA,qCAAqC;EACrC;IACE,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE;MACE,UAAU;MACV,WAAW;MACX,aAAa;IACf;EACF;;EAEA,mCAAmC;EACnC;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;EAC3B;;;EAGA,kDAAkD;EAClD;IACE;MACE,eAAe;IACjB;EACF;;EAEA,sBAAsB;EACtB;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA,mBAAmB;EACnB;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,2BAA2B;EAC3B;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA,mCAAmC;EACnC;IACE,SAAO;IACP,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA,eAAe;EACf;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;EAChB;;EAEA,iFAAiF;EACjF;IACE;MACE,UAAU;MACV,WAAW;MACX,iBAAiB;MACjB,6BAA6B;MAC7B,aAAa;MACb,QAAQ;IACV;EACF","sourcesContent":["/* Container that holds both the player and the list */\r\n.movies-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    min-height: 100vh;\r\n    font-family: Arial, sans-serif;\r\n    background-color: #121827;\r\n  }\r\n  \r\n  /* RESPONSIVE: For screens below 768px wide, switch to column layout */\r\n  @media (max-width: 768px) {\r\n    .movies-container {\r\n      flex-direction: column;\r\n    }\r\n  }\r\n  \r\n  /* Left side: the video player area */\r\n  .player-container {\r\n    flex: 3;\r\n    padding: 2rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .player-container {\r\n      flex: none;\r\n      width: 100%; \r\n      padding: 1rem;\r\n    }\r\n  }\r\n  \r\n  /* Title at the top of the player */\r\n  .page-title {\r\n    font-size: 2.8rem;\r\n    margin-bottom: 1rem;\r\n    padding-top: 20px;\r\n    text-align: center;\r\n    color: #E4B300;\r\n  }\r\n  \r\n  /* 16:9 Video Wrapper */\r\n  .iframe-wrapper {\r\n    position: relative;\r\n    width: 100%;\r\n    padding-bottom: 56.25%;\r\n    margin-bottom: 1rem;\r\n    background-color: #000;\r\n    border-radius: 10px;\r\n    border: 2px solid #c79c00;\r\n  }\r\n  \r\n  .video-iframe {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 10px;\r\n    border: 2px solid #c79c00;\r\n  }\r\n  \r\n  \r\n  /* Make the video title smaller on small screens */\r\n  @media (max-width: 768px) {\r\n    .video-title {\r\n      font-size: 2rem;\r\n    }\r\n  }\r\n  \r\n  /* INTRODUCTION CARD */\r\n  .intro-card {\r\n    background-color: #161d2f;\r\n    border: 1px solid #121827;\r\n    border-radius: 6px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    padding: 1rem 1.2rem;\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .intro-title {\r\n    margin-bottom: 0.5rem;\r\n    font-size: 1.3rem;\r\n    font-weight: bold;\r\n    color: #E4B300;\r\n  }\r\n  \r\n  .intro-text {\r\n    font-size: 1rem;\r\n    line-height: 1.5;\r\n    color: #777;\r\n  }\r\n  \r\n  /* SUMMARY BUTTON */\r\n  .summary-btn {\r\n    background-color: #E4B300;\r\n    color: #121827;\r\n    border: none;\r\n    padding: 0.6rem 1rem;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-bottom: 1rem;\r\n    font-size: 1rem;\r\n    transition: background 0.2s ease;\r\n  }\r\n  \r\n  .summary-btn:hover {\r\n    background-color: #F4CC00;\r\n  }\r\n  \r\n  /* SUMMARY TEXT CONTAINER */\r\n  .movie-summary {\r\n    background-color: #161d2f;\r\n    border-radius: 4px;\r\n    padding: 1rem;\r\n    margin-bottom: 1rem;\r\n    font-size: 1rem;\r\n    color: #777;\r\n  }\r\n  \r\n  /* Right side: Video List Sidebar */\r\n  .Vsidebar {\r\n    flex: 1;\r\n    background-color: #161d2f;\r\n    border-left: 1px solid #121827;\r\n    padding: 2rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .Vsidebar-title {\r\n    font-size: 1.6rem;\r\n    margin-bottom: 1rem;\r\n    color: #E4B300;\r\n  }\r\n  \r\n  /* Video List */\r\n  .video-list {\r\n    list-style-type: none;\r\n  }\r\n  \r\n  .video-list-item {\r\n    cursor: pointer;\r\n    padding: 0.6rem 1rem;\r\n    margin-bottom: 0.5rem;\r\n    border-radius: 4px;\r\n    color: #999;\r\n    transition: background 0.2s ease;\r\n  }\r\n  \r\n  .video-list-item:hover {\r\n    background-color: #F4CC00;\r\n    color: #121827;\r\n  }\r\n  \r\n  .active {\r\n    background-color: #E4B300;\r\n    font-weight: bold;\r\n    color: #121827;\r\n  }\r\n  \r\n  /* RESPONSIVE: For screens below 768px wide, place the sidebar under the player */\r\n  @media (max-width: 768px) {\r\n    .Vsidebar {\r\n      flex: none; \r\n      width: 100%;\r\n      border-left: none;\r\n      border-top: 1px solid #161d2f;\r\n      padding: 1rem;\r\n      order: 2;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
